"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const useAuth_1 = require("lincd-auth/lib/hooks/useAuth");
const JSONParser_1 = require("lincd-jsonld/lib/utils/JSONParser");
function MagicLinkCallback({ indexRoute, renderLoading, }) {
    const [searchParams] = (0, react_router_dom_1.useSearchParams)();
    const token = searchParams.get('token');
    const auth = (0, useAuth_1.useAuth)();
    const [error, setError] = react_1.default.useState(null);
    (0, react_1.useEffect)(() => {
        // verify the url callback, if match will redirect to index path
        const verify = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield fetch(`/auth/magiclogin/callback?token=${token}`);
                if (response.ok) {
                    let text = yield response.text();
                    let result = yield JSONParser_1.JSONParser.parse(text);
                    const { success, data } = result.content;
                    // const {auth,accessToken,refreshToken] = data;
                    console.log(text, result);
                    //bug fix, for some reason magiclogin backend sends Authentication object, but it has no properties when it arrives here
                    data.loginData.auth.userAccount = data.userAccount;
                    if (success) {
                        auth.updateAuth(data.loginData.auth, data.loginData.accessToken, data.loginData.refreshToken);
                    }
                    window.location.assign(indexRoute.path);
                }
                else {
                    console.log('Authentication failed');
                    setError('invalid login link');
                }
            }
            catch (err) {
                console.error('Error during authentication:', err);
                setError('could not verify this link');
            }
        });
        verify();
    }, [token]);
    // check if renderLoading is a function
    if (typeof renderLoading === 'function') {
        return renderLoading() || react_1.default.createElement("div", null, "...");
    }
    else {
        return error ? react_1.default.createElement("div", null, error) : react_1.default.createElement("div", null, "...");
        // return <div>...</div>;
    }
}
exports.default = MagicLinkCallback;
//# sourceMappingURL=MagicLoginCallback.js.map